import { Encoder } from '@everyboard/lib';
import { Coord } from '../../jscaip/Coord';
import { CoordSet } from '../../jscaip/CoordSet';
import { Move } from '../../jscaip/Move';
export class HexodiaMove extends Move {
    coords;
    static of(coords) {
        return new HexodiaMove(new CoordSet(coords));
    }
    static encoder = Encoder.tuple([Encoder.list(Coord.encoder)], (move) => [move.coords.toList()], (value) => HexodiaMove.of(value[0]));
    constructor(coords) {
        super();
        this.coords = coords;
    }
    toString() {
        return 'HexodiaMove(' + this.coords.toList().map((coord) => coord.toString()).join(', ') + ')';
    }
    equals(other) {
        return this.coords.equals(other.coords);
    }
}
